import { FC } from 'react'

import { SellTreez } from '@/models/sellTreez'

interface Props {
  sellTreez?: SellTreez
}

const SellTreezRawTabContent: FC<Props> = ({ sellTreez }) => {
  const outputs = JSON.parse(sellTreez?.outputs ?? '{}')

  return (
    <pre className="rounded-lg border border-gray-100 p-6 text-gray-500 text-sm overflow-auto">
      {JSON.stringify({ ...sellTreez, outputs }, null, 2)}
    </pre>
  )
}

export { SellTreezRawTabContent }
